<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getJigs" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-sm="4" label-cols-lg="3" label="Code"
							label-for="filter-code" size="sm" :model.sync="filter.code" />
						<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name"
							label-for="filter-name" size="sm" :model.sync="filter.name" />
						<app-input-textbox id="fieldset-jig-long" label-cols-sm="4" label-cols-lg="3" label="Long"
							label-for="filter-jig-long" size="sm" :model.sync="filter.jigLong" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-height" label-cols-sm="4" label-cols-lg="3" label="Height"
							label-for="filter-height" size="sm" :model.sync="filter.height" />
						<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark"
							label-for="filter-remark" size="sm" :model.sync="filter.remarkMultiple" />
						<app-input-textbox id="fieldset-wide" label-cols-sm="4" label-cols-lg="3" label="Wide"
							label-for="filter-wide" size="sm" :model.sync="filter.wide" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getJigs"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span>
							Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Jig</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/jig/Jig.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download
								Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item>
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" to="/jig/create" size="sm"> <b-icon-plus-square
									class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" to="/jig/create" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download
							class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton" :show="isDeleteBusy" rounded opacity="0.6" spinner-small
						spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
							countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-jig"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true"
					:no-local-sorting="true" :items="jigs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="jigs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Code" class="table-filter">
							<b-form-input id="input-code-table" @input="getJigsWithoutLoading" v-model="filter.code"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Name" class="table-filter">
							<b-form-input id="input-name-table" @input="getJigsWithoutLoading" v-model="filter.name"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Long" class="table-filter">
							<b-form-input id="input-jig-long-table" @input="getJigsWithoutLoading" v-model="filter.jigLong"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Height" class="table-filter">
							<b-form-input id="input-height-table" @input="getJigsWithoutLoading" v-model="filter.height"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Remark" class="table-filter">
							<b-form-input id="input-remark-table" @input="getJigsWithoutLoading" v-model="filter.remark"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Wide" class="table-filter">
							<b-form-input id="input-wide-table" @input="getJigsWithoutLoading" v-model="filter.wide"
								size="sm"></b-form-input>
						</b-th>

						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all"
								class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(code)="row">
						<a @click="() => ($router.push({ name: 'jigdetail', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.code != null && row.item.code != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.code.slice(0, 30) + (row.item.code.length > 30 ? "..." : "") : row.item.code : "" }}
						</a>
					</template>

					<template v-slot:cell(remark)="row">
						<app-long-text :id="'remark-' + row.index"
							:text="row.item != null ? (row.item.remark != null && row.item.remark != '' ? row.item.remark : '') : ''" />
					</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button> -->
							<b-button class="d-sm-none d-md-inline btn-outline-success" @click="showPopUpQr(row.item)"
								size="sm">Print
								QR</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-textbox id="fieldset-jig-long" label-cols-lg="12" label="Long"
								label-for="input-jig-long" size="sm" :model.sync="row.item.jigLong" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-height" label-cols-lg="12" label="Height"
								label-for="input-height" size="sm" :model.sync="row.item.height" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
								label-for="input-remark" size="sm" :model.sync="row.item.remark" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-wide" label-cols-lg="12" label="Wide" label-for="input-wide"
								size="sm" :model.sync="row.item.wide" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(jigsPaging != null ? jigsPaging.dataCount : 0)"
									:per-page="(jigsPaging != null ? jigsPaging.pageSize : 0)" aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId" @resetModalMethod="resetModal"
			label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-jig.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-jig.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}
</style>
<script>
import Jig from '@/models/Jig/Jig';
import JigList from '@/models/Jig/JigList';
import JigFilter from '@/filters/Jig/JigFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		Jig,
		JigList,
		JigFilter,
		AppInputTextbox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "code": {}, "class": "th-code first-child", "label": "Code", key: 'code', sortable: true },
				{ "name": {}, "class": "th-name", "label": "Name", key: 'name', sortable: true },
				{ "jigLong": {}, "class": "th-jig-long last-child", "label": "Long", key: 'jigLong', sortable: true },
				{ "height": {}, "class": "th-height d-stack-none", "label": "Height", key: 'height', sortable: true },
				{ "remark": {}, "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: true },
				{ "wide": {}, "class": "th-wide d-stack-none", "label": "Wide", key: 'wide', sortable: true },

				{ "actions": { "class": "th-actions", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			jigs: [],
			jigsPaging: {},

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	}, methods: {
		showPopUpQr(item) {
		},
		getJigs: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			Jig.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.jigs = result.data
						this.jigsPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getJigsWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			Jig.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.jigs = result.data
						this.jigsPaging = result
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new JigFilter();
			this.getJigs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getJigs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				Jig.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			Jig.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			console.log('this.filter', this.filter);
			Jig.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					console.log('result ', result);
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},

		deleteData(id) {
			Jig.deleteData(this, id).then(result => {
				if (result) {
					this.getJigs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				Jig.deleteMultipleData(this).then(result => {
					this.getJigs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableJigParent = document.getElementById('table-list-jig').parentNode;
			tableJigParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableJigParent.scrollWidth - tableJigParent.offsetWidth) == Math.ceil(tableJigParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableJigParent = document.getElementById('table-list-jig').parentNode;
			tableJigParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableJigParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new JigFilter();
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Jig"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getJigs();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getJigs();
			}
		},
		sortDesc: {
			handler: function () {
				this.getJigs();
			}
		},
		currentPage: {
			handler: function () {
				this.getJigs();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getJigs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				Jig.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "jigindex") {
					this.getJigsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "jig").first();
		},
		isShowDeleteButton: function () {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
